(function () {
  'use strict';

  /* ==========================================
     CONFIGURATION
  ========================================== */

  var productFetchUrl =
    'https://api.bombayhair.ca/ca/inventory-quantity/product';

  var excludedProductIds = [
    '4889212616778',
    '7023857107018',
    '7023857172554'
  ];

  var currentProductId = null;
  var inventoryData = null;
  var customInventoryData = null;
  var initialized = false;
  var updateTimer = null;
  var startupTimer = null;
  var startupAttempts = 0;
  var maxStartupAttempts = 100;
  var observer = null;
  var pageObserver = null;
  var lastVariantId = null;

  /* ==========================================
     HELPERS
  ========================================== */

  function isValidVariantId(value) {
    return /^\d+$/.test(String(value || '').trim());
  }

  function getProductElement() {
    return document.querySelector(
      '#product-right [data-backorder-current-product-id]'
    );
  }

  function getAddToCartWrapper() {
    return document.querySelector('.add-to-cart-wrapper');
  }

  function getProductForm() {
    return document.querySelector(
      '#product-right form[action*="/cart/add"]'
    ) || document.querySelector(
      'form[action*="/cart/add"]'
    );
  }

  /* ==========================================
     GET SELECTED VARIANT ID
  ========================================== */

  function getSelectedVariantId() {
    /*
     * First, use the variant ID from the product form.
     * Shopify themes commonly keep the selected variant
     * in an input named "id".
     */
    var productForm = getProductForm();

    if (productForm) {
      var formVariantInput = productForm.querySelector(
        'input[name="id"], select[name="id"]'
      );

      if (
        formVariantInput &&
        isValidVariantId(formVariantInput.value)
      ) {
        return String(formVariantInput.value).trim();
      }
    }

    /*
     * Fallback: search all product variant ID inputs.
     * Some themes render more than one product form.
     */
    var variantInputs = document.querySelectorAll(
      '#product-right [name="id"], form[action*="/cart/add"] [name="id"]'
    );

    for (var i = 0; i < variantInputs.length; i++) {
      if (isValidVariantId(variantInputs[i].value)) {
        return String(variantInputs[i].value).trim();
      }
    }

    /*
     * Fallback for themes that expose variant ID
     * through the older backorder swatch markup.
     */
    var checkedInput = document.querySelector(
      '.ib-prod-varient-backorder-flex ' +
      '.product-container-backorder input:checked'
    );

    if (checkedInput) {
      var checkedContainer = checkedInput.closest(
        '.product-container-backorder'
      );

      if (checkedContainer) {
        var checkedVariantElement =
          checkedContainer.querySelector(
            '[data-length-swatch-variant-id]'
          );

        if (checkedVariantElement) {
          var checkedVariantId =
            checkedVariantElement.getAttribute(
              'data-length-swatch-variant-id'
            );

          if (isValidVariantId(checkedVariantId)) {
            return String(checkedVariantId);
          }
        }
      }
    }

    /*
     * Fallback for swatches that use selected/active classes.
     */
    var selectedContainer = document.querySelector(
      '.ib-prod-varient-backorder-flex ' +
      '.product-container-backorder.selected, ' +
      '.ib-prod-varient-backorder-flex ' +
      '.product-container-backorder.active'
    );

    if (selectedContainer) {
      var selectedVariantElement =
        selectedContainer.querySelector(
          '[data-length-swatch-variant-id]'
        );

      if (selectedVariantElement) {
        var selectedVariantId =
          selectedVariantElement.getAttribute(
            'data-length-swatch-variant-id'
          );

        if (isValidVariantId(selectedVariantId)) {
          return String(selectedVariantId);
        }
      }
    }

    /*
     * Final fallback: variant parameter in the URL.
     */
    var urlVariantId = new URLSearchParams(
      window.location.search
    ).get('variant');

    if (isValidVariantId(urlVariantId)) {
      return String(urlVariantId).trim();
    }

    return null;
  }

  /* ==========================================
     UPDATE BACKORDER MESSAGE
  ========================================== */

  function addbackorder_and_lessthan_stock(quantity) {
    var addToCartDiv = getAddToCartWrapper();
    var selectionDiv = document.querySelector(
      '.ibat-your-selection'
    );

    if (!addToCartDiv) {
      return;
    }

    if (
      quantity === null ||
      quantity === undefined ||
      quantity === ''
    ) {
      return;
    }

    var qty = Number(quantity);

    /*
     * Negative API values (such as -1) are treated as
     * unknown inventory, not as zero stock.
     */
if (!Number.isFinite(qty)) {
  return;
}

var message = '';

if (qty <= 0) {
  message = 'Backorder: Ships Once In Stock';
} 

    var existingMessage = document.querySelector(
      '.ibat-backorder'
    );

    if (message) {
      if (!existingMessage) {
        addToCartDiv.insertAdjacentHTML(
          'beforebegin',
          '<div class="ibat-backorder"><span></span></div>'
        );

        existingMessage = document.querySelector(
          '.ibat-backorder'
        );
      }

      if (existingMessage) {
        var messageSpan =
          existingMessage.querySelector('span');

        if (messageSpan) {
          messageSpan.textContent = message;
        } else {
          existingMessage.textContent = message;
        }
      }

      if (
        selectionDiv &&
        selectionDiv.classList.contains(
          'ibat-without-backorder'
        )
      ) {
        selectionDiv.classList.remove(
          'ibat-without-backorder'
        );
      }
    } else {
      if (existingMessage) {
        existingMessage.remove();
      }

      if (
        selectionDiv &&
        !selectionDiv.classList.contains(
          'ibat-without-backorder'
        )
      ) {
        selectionDiv.classList.add(
          'ibat-without-backorder'
        );
      }
    }

    console.log(
      'Backorder status:',
      qty,
      message || 'In stock'
    );
  }

  /* ==========================================
     UPDATE SELECTED SHOPIFY VARIANT
  ========================================== */

  function updateSelectedShopifyVariant() {
    if (
      !inventoryData ||
      !currentProductId ||
      excludedProductIds.includes(currentProductId)
    ) {
      return;
    }

    var variantId = getSelectedVariantId();

    if (!variantId) {
      return;
    }

    var productInventory =
      inventoryData[currentProductId];

    if (!productInventory) {
      console.warn(
        'Backorder: Product missing from API response.',
        currentProductId
      );
      return;
    }

    var quantity = productInventory[variantId];

    if (quantity === undefined || quantity === null) {
      console.warn(
        'Backorder: Quantity missing for variant.',
        variantId
      );
      return;
    }

    lastVariantId = variantId;

    console.log(
      'Backorder: Selected variant:',
      variantId,
      'Quantity:',
      quantity
    );

    addbackorder_and_lessthan_stock(quantity);
  }

  /* ==========================================
     SCHEDULE VARIANT STATUS UPDATE
  ========================================== */

  function scheduleVariantUpdate(delay) {
    if (updateTimer) {
      clearTimeout(updateTimer);
    }

    updateTimer = setTimeout(function () {
      updateSelectedShopifyVariant();
    }, typeof delay === 'number' ? delay : 200);
  }

// new
  function updateVariantPickerBackorderLabels() {
  if (!inventoryData || !currentProductId) return;

  var productInventory = inventoryData[currentProductId];
  if (!productInventory) return;

  var pickerOptions = document.querySelectorAll(
    'variant-selects.ib-custom-product-variant-picker-color-swatch ' +
    '.ib-custom-product-variant-picker-color-swatch__option'
  );

  pickerOptions.forEach(function (option) {
    var input = option.querySelector(
      '.ib-custom-product-variant-picker-color-swatch__input'
    );

    if (!input) return;

    var variantId = String(input.getAttribute('data-variant-id') || '');
    if (!variantId) return;

    var quantity = productInventory[variantId];

    if (quantity === undefined || quantity === null || quantity === '') {
      option.classList.remove('is-backorder');
      return;
    }

    var qty = Number(quantity);

    if (Number.isFinite(qty) && qty <= 0) {
      option.classList.add('is-backorder');
    } else {
      option.classList.remove('is-backorder');
    }
  });
}

// new

  /* ==========================================
     FETCH SHOPIFY VARIANT INVENTORY
  ========================================== */

  async function fetchShopifyInventory() {
    if (
      !currentProductId ||
      excludedProductIds.includes(currentProductId)
    ) {
      return;
    }

    try {
      var response = await fetch(productFetchUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          productIds: [Number(currentProductId)]
        })
      });

      if (!response.ok) {
        throw new Error(
          'Inventory API error: ' + response.status
        );
      }

      var data = await response.json();
      inventoryData = data;

      //new
      updateVariantPickerBackorderLabels();
      //new

      console.log(
        'Backorder: Shopify inventory response:',
        inventoryData
      );

      /*
       * Update labels inside the legacy Shopify swatches,
       * if those swatches exist on this template.
       */
      var shopifySwatches = document.querySelectorAll(
        '.ib-prod-varient-backorder-flex ' +
        '.product-container-backorder'
      );

      shopifySwatches.forEach(function (swatch) {
        var variantElement = swatch.querySelector(
          '[data-length-swatch-variant-id]'
        );

        if (!variantElement) return;

        var variantId = String(
          variantElement.getAttribute(
            'data-length-swatch-variant-id'
          )
        );

        var quantity =
          inventoryData[currentProductId] &&
          inventoryData[currentProductId][variantId];

        var existingLabel = swatch.querySelector(
          '.ib-inside-length-backorder'
        );

        var numericQuantity = Number(quantity);

        if (
          quantity !== undefined &&
          quantity !== null &&
          Number.isFinite(numericQuantity) &&
          numericQuantity === 0
        ) {
          if (!existingLabel) {
            swatch.insertAdjacentHTML(
              'beforeend',
              '<span class="ib-inside-length-backorder">' +
              ' (Backorder) ' +
              '</span>'
            );
          }

          swatch.classList.add('ibat-below-btm');
        } else {
          if (existingLabel) {
            existingLabel.remove();
          }

          swatch.classList.remove('ibat-below-btm');
        }
      });

            // Apply Backorder labels to the custom variant picker
      updateVariantPickerBackorderLabels();

      // new

      /*
       * Update immediately, then retry briefly in case
       * the theme sets the selected variant after load.
       */
      scheduleVariantUpdate(0);
      retryInitialVariantUpdate();

    } catch (error) {
      console.error(
        'Backorder: Shopify inventory fetch failed:',
        error
      );
    }
  }

  /* ==========================================
     INITIAL VARIANT RETRY
  ========================================== */

  function retryInitialVariantUpdate() {
    var tries = 0;
    var maxTries = 30;

    function retry() {
      if (tries >= maxTries) return;

      var variantId = getSelectedVariantId();

      if (variantId) {
        scheduleVariantUpdate(0);
      }

      tries++;

      if (tries < maxTries) {
        setTimeout(retry, 150);
      }
    }

    retry();
  }

  /* ==========================================
     FETCH CUSTOM LENGTH SWATCH INVENTORY
  ========================================== */

  async function fetchCustomSwatchInventory() {
    var customSwatches = document.querySelectorAll(
      '.length-swatch-btn'
    );

    if (!customSwatches.length) return;

    var productIds = Array.from(customSwatches)
      .map(function (swatch) {
        return swatch.getAttribute('data-product-id');
      })
      .filter(Boolean);

    productIds = Array.from(new Set(productIds));

    if (!productIds.length) return;

    try {
      var response = await fetch(productFetchUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          productIds: productIds.map(Number)
        })
      });

      if (!response.ok) {
        throw new Error(
          'Custom inventory API error: ' + response.status
        );
      }

      var data = await response.json();
      customInventoryData = data;

      console.log(
        'Backorder: Custom swatch inventory response:',
        customInventoryData
      );

      customSwatches.forEach(function (swatch) {
        var productId = String(
          swatch.getAttribute('data-product-id')
        );

        var productInventory =
          customInventoryData[productId];

        if (!productInventory) return;

        var quantity = Number(
          Object.values(productInventory)[0]
        );

        if (
          Number.isFinite(quantity) &&
          quantity === 0
        ) {
          swatch.classList.add(
            'is-out-of-stock-length'
          );
        } else {
          swatch.classList.remove(
            'is-out-of-stock-length'
          );
        }
      });

      /*
       * For custom-length products without Shopify swatches,
       * show the first returned custom inventory quantity.
       */
      var hasShopifySwatches = document.querySelector(
        '.ib-prod-varient-backorder-flex ' +
        '.product-container-backorder'
      );

      if (
        !hasShopifySwatches &&
        !excludedProductIds.includes(currentProductId)
      ) {
        var currentInventory =
          customInventoryData[currentProductId];

        if (currentInventory) {
          addbackorder_and_lessthan_stock(
            Object.values(currentInventory)[0]
          );
        }
      }

    } catch (error) {
      console.error(
        'Backorder: Custom inventory fetch failed:',
        error
      );
    }
  }

  /* ==========================================
     VARIANT CHANGE LISTENERS
  ========================================== */

  /*
   * Catch variant changes from standard Shopify product
   * forms and custom option selectors.
   */
  document.addEventListener('change', function (event) {
    var target = event.target;

    if (!target || !target.matches) return;

    if (
      target.matches(
        'form[action*="/cart/add"] [name="id"], ' +
        '#product-right [name="id"], ' +
        '#product-right select, ' +
        '#product-right input[type="radio"], ' +
        '#product-right input[type="checkbox"], ' +
        '.ib-prod-varient-backorder-flex input'
      )
    ) {
      scheduleVariantUpdate(100);
      setTimeout(function () {
        scheduleVariantUpdate(0);
      }, 300);
    }
  });

  /*
   * Catch swatch clicks where the theme updates the
   * selected variant through JavaScript.
   */
  document.addEventListener('click', function (event) {
    var target = event.target;

    if (!target || !target.closest) return;

    if (
      target.closest(
        '#product-right [data-variant-id], ' +
        '#product-right [data-value], ' +
        '#product-right .product-container-backorder, ' +
        '#product-right .length-swatch-btn, ' +
        '#product-right label, ' +
        '#product-right button'
      )
    ) {
      scheduleVariantUpdate(150);

      setTimeout(function () {
        scheduleVariantUpdate(0);
      }, 350);
    }
  });

  /*
   * Observe the old swatch container when present.
   */
  function observeVariantContainer() {
    var variantContainer = document.querySelector(
      '.ib-prod-varient-backorder-flex'
    );

    if (!variantContainer || observer) return;

    observer = new MutationObserver(function () {
      scheduleVariantUpdate(100);
    });

    observer.observe(variantContainer, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: [
        'checked',
        'class',
        'value'
      ]
    });
  }

  /* ==========================================
     INITIALIZATION
  ========================================== */

  function initBackorderScript() {
    if (initialized) return true;

    var productElement = getProductElement();
    var addToCartDiv = getAddToCartWrapper();

    if (!productElement || !addToCartDiv) {
      return false;
    }

    var rawProductId = productElement.getAttribute(
      'data-backorder-current-product-id'
    );

    var numericProductId = Number(rawProductId);

    if (
      !Number.isFinite(numericProductId) ||
      numericProductId <= 0
    ) {
      console.warn('Backorder: Invalid product ID.', rawProductId);
      return false;
    }

    currentProductId = String(
      Math.floor(numericProductId)
    );

    initialized = true;

    console.log(
      'Backorder: Initialized for product',
      currentProductId
    );

    /*
     * Start fetching as soon as the product container exists.
     * Do not wait for the variant ID: some themes set it later.
     */
    fetchShopifyInventory();
    fetchCustomSwatchInventory();
    observeVariantContainer();

    return true;
  }

  function waitForBackorderElements() {
    if (initialized) return;

    if (initBackorderScript()) {
      return;
    }

    startupAttempts++;

    if (startupAttempts < maxStartupAttempts) {
      startupTimer = setTimeout(
        waitForBackorderElements,
        100
      );
    } else {
      console.warn(
        'Backorder: Product elements did not become ready.'
      );
    }
  }

  function startBackorder() {
    waitForBackorderElements();

    /*
     * If Shopify inserts/replaces the product section after
     * initial page load, retry initialization. Once initialized,
     * observe the variant swatch area rather than repeatedly
     * starting new initialization loops.
     */
    if (pageObserver) return;

    pageObserver = new MutationObserver(function () {
      if (!initialized) {
        if (startupTimer) {
          clearTimeout(startupTimer);
        }

        waitForBackorderElements();
      } else {
        observeVariantContainer();
      }
    });

    pageObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    /*
     * Briefly re-check the selected variant during initial render.
     * This covers themes that populate the form after DOM ready.
     */
    retryInitialVariantUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startBackorder,
      { once: true }
    );
  } else {
    startBackorder();
  }

})();

































// var currentproduct_id = [...document.querySelectorAll('#product-right [data-backorder-current-product-id]')][0].getAttribute("data-backorder-current-product-id");
// var currentproductidnumber = Math.floor(currentproduct_id);
// var swatches_shopify_length_varaint = [...document.querySelectorAll('.ib-prod-varient-backorder-flex .product-container-backorder')];
// var swatches_custom_length_varaint = [...document.querySelectorAll('.length-swatch-btn')];
// var productfetch_url = 'https://api.bombayhair.ca/ca/inventory-quantity/product';
// var selection_div_for_padd = [...document.querySelectorAll('.ibat-your-selection')][0];
// var addtocart_div = [...document.querySelectorAll('.add-to-cart-wrapper')][0]; 
// /* ------------------- Backorder for Shhopify Variant Length and other Swatches ---------- */
// var inven_qunty_prod_var_datafetch;
// var currentproductbody = {
//   productIds: [currentproductidnumber]
// };
// fetch(productfetch_url, {
//   method: 'POST',
//   headers: {
//     'Content-Type': 'application/json'
//   },
//   body: JSON.stringify(currentproductbody)
// }).then(response => {
//   if (!response.ok) {
//     throw new Error('Network response was not ok');
//   }
//   return response.json();
// }).then(data => {
//   inven_qunty_prod_var_datafetch = data;
//   /*  Check if the variable[array] "swatches_shopify_length_varaint" having any element or not  */
//   if(swatches_shopify_length_varaint.length){
//     // we did not change currentproductidnumber id
//       if(currentproductidnumber != '4889212616778' && currentproductidnumber != '7023857107018' && currentproductidnumber != '7023857172554'){
//       swatches_shopify_length_varaint.forEach((elem) => {
//         var variant_swatchid_elem_arr = Math.floor(elem.children[0].getAttribute("data-length-swatch-variant-id"));  
//         if(inven_qunty_prod_var_datafetch[currentproductidnumber][variant_swatchid_elem_arr] <= 0){
//           elem.insertAdjacentHTML('beforeend','<span class="ib-inside-length-backorder"> (Backorder) </span>');
//           elem.classList.add('ibat-below-btm');          
//         }
//       });
//       /*  Displaying Backorder for Shopify Variant  */
//       var currentactive_shopify_variant = [...document.querySelectorAll('.ib-prod-varient-backorder-flex .product-container-backorder input[checked]')][0].parentElement.querySelectorAll('[data-length-swatch-variant-id]')[0].getAttribute('data-length-swatch-variant-id');
//       var inventory_qty_shopifyvar_active = inven_qunty_prod_var_datafetch[currentproductidnumber][currentactive_shopify_variant];
//       addbackorder_and_lessthan_stock(inventory_qty_shopifyvar_active);
//       /*  Displaying Backorder for Shopify Variant - END  */
//     }
//   }
//   else{
//     /*  Doesn't contain any variant  */
//     // console.log(currentproductidnumber);
//     // we did not change currentproductidnumber id
//     if(currentproductidnumber != '4889212616778' && currentproductidnumber != '7023857107018' && currentproductidnumber != '7023857172554'){
//       var current_prod_not_having_variant_invenqty = Object.values(inven_qunty_prod_var_datafetch[currentproductidnumber])[0];
//       addbackorder_and_lessthan_stock(current_prod_not_having_variant_invenqty);
//     }
//   }
// }).catch(error => {
//   console.error('There was a problem with the fetch operation:', error);
// });
// /* ----------- End -- Backorder for Shopify Length and other Swatches ------------ */

// /* ------------------- Backorder for Custom Length Swatches   ---------- */
// /*  Check if the variable[array] "swatches_custom_length_varaint" having any element or not  */
// if(swatches_custom_length_varaint.length){
//   var productid_customlength_array_for_fetch_data = [];
//   var allproduct_inven_quantity_for_custom_length_vardata = [];
//   swatches_custom_length_varaint.forEach((elem) => {
//     productid_customlength_array_for_fetch_data.push(elem.getAttribute("data-product-id"));
//   });
//   var lengthvaraintproductbody = {
//     productIds: productid_customlength_array_for_fetch_data
//   };
//   fetch(productfetch_url, {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify(lengthvaraintproductbody)
//   }).then(response => {
//     if (!response.ok) {
//       throw new Error('Network response was not ok');
//     }
//     return response.json();
//   }).then(data => {
//     allproduct_inven_quantity_for_custom_length_vardata = data;
//     swatches_custom_length_varaint.forEach((elem) => {

//   var variant_custom_swatchid_elem_arr = elem.getAttribute("data-product-id");

//   if(
//     allproduct_inven_quantity_for_custom_length_vardata[variant_custom_swatchid_elem_arr] &&
//     Object.values(allproduct_inven_quantity_for_custom_length_vardata[variant_custom_swatchid_elem_arr])[0] <= 0
//   ){
//     elem.classList.add('is-out-of-stock-length');
//   }
//   else{
//     elem.classList.remove('is-out-of-stock-length');
//   }
//     });
//     /*  For onload Custom varaint  */
//     var current_len_var_custom_inven_qty = Object.values(allproduct_inven_quantity_for_custom_length_vardata[currentproductidnumber])[0];
//     addbackorder_and_lessthan_stock(current_len_var_custom_inven_qty);
//     /*  For onload Custom varaint END */
//   }).catch(error => {
//     console.error('There was a problem with the fetch operation:', error);
//   });
// }
// /* ----------- End -- Backorder for Custom Length Swatches ------------ */
// // if (variant.id == variant_url_id && data.id != '7023857172554' && data.id != '7023857107018' && data.id != '4889212616778') {

// var start_url = window.location.href;
// var click_for_loc_chng = [...document.querySelectorAll('.ib-prod-varient-backorder-flex .product-container-backorder input')];
// click_for_loc_chng.forEach(input_click => {
//   input_click.addEventListener("click", function (e) {
//     console.log("shopify variant")
//     setTimeout(function () {
//       // setTimeout(function () {
//       //   console.log("Inside the backorder function");
//       // const source = document.getElementById("ib-product-price");
//       // const source2 = document.getElementById("ib-compare-at-price");
//       // const target = document.getElementById("price-under");
//       // const target2 = document.getElementById("price-under-compare");
      
//       // const timed = setInterval(() => {

//       // //   console.log(source.innerHTML.trim())
//       // // console.log(target.innerHTML.trim())
//       //   if((source.innerHTML.trim() != target.innerHTML.trim()) ){
//       //     target.innerHTML = source.innerHTML;
//       //     target2.innerHTML = source2.innerHTML;
//       //     clearTimeout(timed)
//       //   }
//       // }, 50);
    
//       // }, 500);
//       var change_url = window.location.href;
//       if (change_url != start_url) {
//         var urlString_changed = window.location.search;
//           console.log(inven_qunty_prod_var_datafetch);
//         if (urlString_changed.startsWith("?variant=")) {
//           if(currentproductidnumber != 4889212616778 && currentproductidnumber != 7023857107018 && currentproductidnumber != 7023857172554){
//             var variant_url_id = new URLSearchParams(urlString_changed).get("variant");
//             var shopify_inventory_qunatity_switchvariant = inven_qunty_prod_var_datafetch[currentproductidnumber][variant_url_id];
//             addbackorder_and_lessthan_stock(shopify_inventory_qunatity_switchvariant);
//           }
//         }
//         start_url = change_url;
//       }
//     }, 800);
//   });
// });

// /* ------ Function START for adding backorder/removing backorder/ adding less than 4 in stock  ------- */
// function addbackorder_and_lessthan_stock(inven_qty_no) {
//   var backorder_div_variant_change = [...document.querySelectorAll('.ibat-backorder')][0];
//   var selection_div_for_padd_change = [...document.querySelectorAll('.ibat-your-selection')][0];
//   console.log(inven_qty_no);
//   if(inven_qty_no <= 0){
//     if(!backorder_div_variant_change){
//       addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Backorder: Ships Once In Stock</span></div>');
//       if(selection_div_for_padd_change && selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
//         selection_div_for_padd_change.classList.remove('ibat-without-backorder');
//       }
//     }
//     else if(backorder_div_variant_change.innerText.toLowerCase() != "backorder: ships once in stock"){
//       backorder_div_variant_change.remove();
//       addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Backorder: Ships Once In Stock</span></div>');
//       if(selection_div_for_padd_change && selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
//         selection_div_for_padd_change.classList.remove('ibat-without-backorder');
//       }
//     }
//   } 
//   else if(inven_qty_no <= 4 && inven_qty_no >= 1){
//     if(!backorder_div_variant_change){
//       addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Less than 4 In Stock</span></div>');
//       if(selection_div_for_padd_change && selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
//         selection_div_for_padd_change.classList.remove('ibat-without-backorder');
//       }
//     }
//     else if(backorder_div_variant_change.innerText.toLowerCase() != "less than 4 in stock"){
//       backorder_div_variant_change.remove();
//       addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Less than 4 In Stock</span></div>');
//       if(selection_div_for_padd_change && selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
//         selection_div_for_padd_change.classList.remove('ibat-without-backorder');
//       }
//     }
//   }
//   else {
//     if(backorder_div_variant_change){
//       backorder_div_variant_change.remove();
//       if(!selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
//         selection_div_for_padd_change.classList.add('ibat-without-backorder');
//       }
//     }
//   }
// }
// /* ------ Function END for adding backorder/removing backorder/ adding less than 4 in stock  ------- */